import { useMemo } from 'react';
import PortalIdParser from 'PortalIdParser';
import { Button } from 'foundations-components/transitional/components/Button';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { useObjectId } from '../../../v2/hooks/useObjectId';
import { LINE_ITEM_TYPE_ID, PRODUCT_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useObjectTypeId } from '../../../v2/hooks/useObjectTypeId';
import { useTieredPriceConfigContext } from '../../../context/TieredPriceConfigContext';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const TiersSecondaryActionButton = ({
  objectTypeId,
  buttonProps,
  readOnly
}) => {
  const Content = useMemo(() => {
    if (objectTypeId === PRODUCT_TYPE_ID) {
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "customerDataProperties.tieredPricing.modal.close"
      });
    }
    if (objectTypeId === LINE_ITEM_TYPE_ID) {
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "customerDataProperties.tieredPricing.modal.editLineItem"
      });
    }
    return null;
  }, [objectTypeId]);
  if (readOnly && objectTypeId === LINE_ITEM_TYPE_ID) {
    return null;
  }
  return /*#__PURE__*/_jsx(Button, Object.assign({
    use: "secondary"
  }, buttonProps, {
    "data-test-id": "tiered-price-modal-secondary-actions-btn",
    children: Content
  }));
};
const TiersPrimaryActionButton = ({
  objectTypeId,
  buttonProps,
  readOnly
}) => {
  const Content = useMemo(() => {
    if (objectTypeId === PRODUCT_TYPE_ID) {
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "customerDataProperties.tieredPricing.modal.editProduct"
      });
    }
    if (objectTypeId === LINE_ITEM_TYPE_ID) {
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "customerDataProperties.tieredPricing.modal.save"
      });
    }
    return null;
  }, [objectTypeId]);
  if (readOnly && objectTypeId === PRODUCT_TYPE_ID) {
    return null;
  }
  return /*#__PURE__*/_jsx(Button, Object.assign({
    use: "primary"
  }, buttonProps, {
    "data-test-id": "tiered-price-modal-primary-actions-btn",
    children: Content
  }));
};
export const TieredPriceModalFooter = ({
  onSave,
  onEdit,
  onClose
}) => {
  const {
    readOnly
  } = useTieredPriceConfigContext();
  const objectId = useObjectId();
  const objectTypeId = useObjectTypeId();
  const primaryActionButtonProps = useMemo(() => {
    if (objectTypeId === PRODUCT_TYPE_ID) {
      const productEditorUrl = `/products/${PortalIdParser.get()}/edit/${objectId}`;
      return {
        href: productEditorUrl,
        use: 'secondary'
      };
    } else if (objectTypeId === LINE_ITEM_TYPE_ID) {
      return {
        use: 'primary',
        onClick: onSave
      };
    }
    return undefined;
  }, [objectId, objectTypeId, onSave]);
  const secondaryActionButtonProps = useMemo(() => {
    if (objectTypeId === PRODUCT_TYPE_ID) {
      return {
        use: 'tertiary-light',
        onClick: onClose
      };
    } else if (objectTypeId === LINE_ITEM_TYPE_ID) {
      return {
        onClick: onEdit,
        use: 'secondary'
      };
    }
    return undefined;
  }, [objectTypeId, onEdit, onClose]);
  return /*#__PURE__*/_jsxs(DialogFooter, {
    align: "right",
    "data-test-id": "tiered-price-modal-footer",
    children: [/*#__PURE__*/_jsx(TiersSecondaryActionButton, {
      objectTypeId: objectTypeId,
      buttonProps: secondaryActionButtonProps,
      readOnly: readOnly
    }), /*#__PURE__*/_jsx(TiersPrimaryActionButton, {
      objectTypeId: objectTypeId,
      buttonProps: primaryActionButtonProps,
      readOnly: readOnly
    })]
  });
};